import { buildBracket } from './bracketUtils';

export const generateSingleElimination = (participants) => {
  if (!Array.isArray(participants) || participants.length < 2) {
    throw new Error('Single Elimination needs at least 2 participants');
  }
  const bracket = buildBracket(participants, 'main');
  return {
    formatId: 'single_elimination',
    participantsCount: participants.length,
    bracketSize: bracket.bracketSize,
    byes: bracket.byes,
    rounds: bracket.rounds,
  };
};
